import { useEffect, useState } from 'react'
import { Navigate, Outlet, useParams } from 'react-router'
import { observer } from 'mobx-react-lite'
import { SpinnerLoader } from 'shared/ui'
import { logger } from 'shared/lib'
import { SurveysApi } from 'entities/Surveys'
import { type IResponseFullSurvey } from 'entities/Surveys/api/types'
import { SurveysRoutes } from 'entities/ExportRouters'
import { SurveysIdContext } from 'pages/surveys/context/surveysIdContext'

export const SurveyIdLayout = observer(() => {
  const { id } = useParams()
  const [loading, setLoading] = useState(true)
  const [response, setResponse] = useState<IResponseFullSurvey | null>(null)

  useEffect(() => {
    if (id) {
      const fetchSurvey = async () => {
        try {
          const { data } = await SurveysApi.getSurvey(Number(id))
          setResponse(data)
        } catch (e) {
          logger.error(e)
        } finally {
          setLoading(false)
        }
      }
      fetchSurvey()
      return () => {
        setResponse(null)
        setLoading(true)
      }
    }
  }, [id])

  if (loading) {
    return <SpinnerLoader ariaLabel={'SurveyIdLayout'} />
  }
  if (response) {
    return (
      <SurveysIdContext.Provider value={response}>
        <Outlet />
      </SurveysIdContext.Provider>
    )
  }
  return <Navigate to={`/${SurveysRoutes.root}`} />
})
